module.exports = __webpack_public_path__ + "img/3e41262e29bb9252180cec918b6d099c.png";